import { createContext } from 'react';
import { WorkbenchPortalContextType } from './types';

export const WorkbenchPortalContext = createContext<WorkbenchPortalContextType>(
  {} as unknown as WorkbenchPortalContextType,
);
